export type MediaDescriptorJSON = {
    is_hls: boolean
    media_url: string
}

export type MediaDescriptor = {
    isHls: boolean
    mediaUrl: string
}

export const MediaDescriptor = {
    fromJSON: (json: MediaDescriptorJSON): MediaDescriptor => ({
        isHls: json.is_hls,
        mediaUrl: json.media_url,
    }),
}
